import {
  OfficeAddressEditFormValues,
  OfficeEditFormValues,
  OfficeEmailEditFormValues,
  OfficeNoteEditFormValues,
  OfficePhoneEditFormValues,
  OfficeSearchFormValues,
} from "./types";

/*-------------------------------------------------------------------------------------------
  OFFICE SEARCH
---------------------------------------------------------------------------------------------*/
export const initialOfficeSearchForm: OfficeSearchFormValues = {
  search: "",
};

/*-------------------------------------------------------------------------------------------
  OFFICE EDIT
---------------------------------------------------------------------------------------------*/
export const initialOfficeEditForm: OfficeEditFormValues = {
  name: null,
  code: null,
  internalMark: null,
  description: null,
  status: "active",
};

export const OFFICE_STATUS_OPTIONS = [
  { value: "active", text: "Aktivna" },
  { value: "inactive", text: "Neaktivna" },
  { value: "temporarily_closed", text: "Privremeno zatvorena" },
];

/*-------------------------------------------------------------------------------------------
  OFFICE EMAILS
---------------------------------------------------------------------------------------------*/
export const initialOfficeEmailEditForm: OfficeEmailEditFormValues = {
  emailAddress: null,
  description: null,
  primary: false,
};

/*-------------------------------------------------------------------------------------------
  OFFICE PHONES
---------------------------------------------------------------------------------------------*/
export const initialOfficePhoneEditForm: OfficePhoneEditFormValues = {
  phoneTypeId: "M",
  phoneNumber: null,
  description: null,
  primary: false,
};

/*-------------------------------------------------------------------------------------------
  OFFICE ADDRESS
---------------------------------------------------------------------------------------------*/
export const initialOfficeAddressEditForm: OfficeAddressEditFormValues = {
  city: null,
  country: null,
  line1: null,
  line2: null,
  postalCode: null,
  state: null,
  description: null,
  primary: false,
  latitude: null,
  longitude: null,
};

/*-------------------------------------------------------------------------------------------
  OFFICE NOTE
---------------------------------------------------------------------------------------------*/
export const initialOfficeNoteEditForm: OfficeNoteEditFormValues = {
  content: null,
  important: false,
};

